






















import LazyHydrate from 'vue-lazy-hydration';
import { useRoute, defineComponent, onMounted, onUnmounted } from '@nuxtjs/composition-api';
import { useListen, useUnListen, useUiState } from '@wemade-vsf/composables';
import { useQuoteCartState } from '@wemade-vsf/quote-cart';
import AppHeader from 'components/theme/AppHeader.vue';
import IconSprite from 'components/theme/General/IconSprite.vue';
import LoadWhenVisible from 'components/theme/utils/LoadWhenVisible.vue';

export default defineComponent({
  name: 'DefaultLayout',

  components: {
    LoadWhenVisible,
    LazyHydrate,
    AppHeader,
    IconSprite,
    AppFooter: () => import(/* webpackPrefetch: true */ 'components/theme/AppFooter.vue'),
    CartSidebar: () => import(/* webpackPrefetch: true */ 'components/checkout/CartSidebar.vue'),
    QuoteCartSidebar: () => import(/* webpackPrefetch: true */ 'components/quote-cart/QuoteCartSidebar.vue'),
    LoginModal: () => import(/* webpackPrefetch: true */ 'components/customer/LoginModal/LoginModal.vue'),
    Notification: () => import(/* webpackPrefetch: true */ 'components/theme/Notification.vue'),
  },

  setup() {
    const route = useRoute();
    const {
      isCartSidebarOpen, isLoginModalOpen, toggleLoginModal, toggleCartSidebar
    } = useUiState();
    const { isQuoteCartSidebarOpen, toggleQuoteCartSidebar } = useQuoteCartState();

    function openQuoteSidebar() {
      if (!isQuoteCartSidebarOpen.value) {
        toggleQuoteCartSidebar();
      }
    }

    function openMiniCart() {
      if (!isCartSidebarOpen.value) {
        toggleCartSidebar();
      }
    }

    onMounted(() => {
      useListen('quoteCart:addItem', openQuoteSidebar);
      useListen('cart:addItem', openMiniCart);
    })
    onUnmounted(() => {
      useUnListen('quoteCart:addItem', openQuoteSidebar);
      useUnListen('cart:addItem', openMiniCart);
    })
    return {
      isCartSidebarOpen,
      isLoginModalOpen,
      isQuoteCartSidebarOpen,
      toggleLoginModal,
      route,
    };
  }
});
